/*
 * Api lấy dữ liệu cho nhóm nhà cung cấp
 * pvduy 08/02/2020
 */
import BaseAPI from "./base/base-api";

class AccountObjectGroupAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = "Business";
  controllerName = "AccountObjectGroup";
}

export default new AccountObjectGroupAPI();
